<template>
    <div>

        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <strong>{{ $t('components.accountingReport') }} {{person_name}}</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CRow class="m-1">
                            <CCol col="3">
                                <date-picker
                                        :label="$t('components.startDate')"
                                        v-model="start_date"></date-picker>
                            </CCol>
                            <CCol col="3">
                                <date-picker
                                        :label="$t('components.endDate')"
                                        v-model="end_date"></date-picker>

                            </CCol>

                            <CCol col="1">
                                <CButton @click="get_lists" color="dark"
                                         size="sm">
                                    <CIcon size="sm" name="cil-zoom"/>
                                </CButton>
                            </CCol>
                        </CRow>
                        <CDataTableFixed
                                :items="items_customer"
                                :fields="fields"
                                height="350px"
                                :items-per-page="20"
                                hover
                                border
                                striped
                        >
                            <template #row_id="{item}">

                                <td style="text-align: center">

                                    <p style="text-align: center">{{ item.row_id + 1 }}</p>

                                </td>

                            </template>
                            <template #docDate="{item}">
                                <td>
                                    <p style="text-align: center">{{ get_date(item.docDate) }}</p>
                                </td>
                            </template>
                            <template #statusTitle="{item}">
                                <td>
                                    <p>{{ item.statusTitle }}</p>
                                </td>
                            </template>

                            <template #amount="{item}">
                                <td>
                                    <p style="text-align: right">{{ get_currency(item.amount) }} </p>
                                </td>
                            </template>
                            <template #amountNegetive="{item}">
                                <td>
                                    <p style="text-align: right">{{ get_currency(item.amountNegetive )}} </p>
                                </td>
                            </template>
                            <template #accBalance="{item}">
                                <td>
                                    <p style="text-align: right">{{ get_currency(item.accBalance) }} </p>
                                </td>
                            </template>


                            <template #masterCode="{item}">
                                <td style="text-align: center">
                                    <a href="javascript:void(0)" class="text-primary" v-on:click="goToDocuments(item)">
                                        {{ item.masterCode }}
                                    </a>

                                </td>

                            </template>


                            <template #operation="{item}">
                                <td>
                                    <CButton
                                            class="m-1"
                                            color="primary"
                                            variant="outline"
                                            square
                                            :title="$t('buttons.edit')"

                                            size="sm"
                                            @click="goEditPerson(item)"
                                    >
                                        <CIcon name="cil-pencil"/>
                                    </CButton>
                                    <CButton class="m-1"
                                             color="success"
                                             variant="outline"
                                             square
                                             size="sm"
                                             :title="$t('buttons.documents')"
                                             @click="goToDocuments(item)"
                                    >
                                        <CIcon name="cil-list-rich"/>
                                    </CButton>
                                    <CButton class="m-1"
                                             color="success"
                                             variant="outline"
                                             square
                                             size="sm"
                                             :title="$t('buttons.commission')"
                                             @click="goToPorsant(item)"
                                    >
                                        <CIcon name="cil-dollar"/>
                                    </CButton>
                                </td>
                            </template>


                        </CDataTableFixed>

                    </CCardBody>

                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';

    var items_data = [];


    export default {
        name: 'Login',
        data() {
            return {
                start_date: '',
                end_date: '',
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                VUE_APP_Currency: localStorage.getItem('currency'),
                items_customer: items_data.map((item, row_id) => {
                    if (item.isCustomer) {
                        return {...item, row_id}

                    }
                }),
                fields: [//amount amountNegetive accBalance accBalanceNegetive
                    {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
                    {key: 'docDate', label: this.$t('docDate'), _style: 'width:10%'},
                    {key: 'statusTitle', label: this.$t('components.docType'), _style: 'width:10%'},
                    {key: 'masterCode', label: this.$t('referenceNo'), _style: 'width:10%'},
                    {key: 'amountNegetive', label: this.$t('tables.debtor'), _style: 'width:10%'},
                    {key: 'amount', label: this.$t('tables.creditor'), _style: 'width:10%'},
                    // {key: 'accBalanceNegetive', label: this.$t('tables.debtorBalance'), _style: 'width:10%'},
                    {key: 'accBalance', label: this.$t('tables.balance'), _style: 'width:10%'},
                    // {key: 'statusTitle', label: this.$t('tables.documentType'), _style: 'width:10%'},
                    // {key: 'kardexAccTypeTitle', label: this.$t('tables.type'), _style: 'width:10%'},
                    // {key: 'summary', label: this.$t('tables.summary'), _style: 'width:10%'},

                    // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

                ],
                templates_items: [],
                collapseDuration: 0,
                person_name: '',
                status_form: 0
            }
        }, mounted() {
            this.start_date = this.get_day_before_today(1);
            this.end_date = this.get_today();

            this.$root.root_validate_errors = [];
            this.get_lists();

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            '$route.params.cat_id': function () {
                this.get_lists();
            }
        },
        methods: {
            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = item.unitName;
                this.color = item.color;
                this.description = item.description;
                this.previewImage = item.image;
                this.status_form = item.id;
            },
            emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = '';
                this.color = '';
                this.description = '';
                this.previewImage = '';
                this.status_form = 0;

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            }, edit_sale_method(item) {
                this.selected_method = item.saleMethodId;
                this.selected_person = item.userId;
                this.saleMethodModal = true;

            },
            get_lists() {
                var self = this;


                const formData = new FormData();

                var url = "GetPersonAccountsByPersonId";

                formData.append('id', self.$route.params.user_id);
                formData.append('FirstDate', self.start_date);
                formData.append('SecondDate', self.end_date);


                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;
                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.person_name = content_data.data.personName;

                        self.items_customer = content_data.data.personAccountItems.map((item, row_id) => {
// if(item.isCustomer){
                            return {...item, row_id}
                        });
                        var total = 0;

                        self.items_customer.forEach(function (val) {
                          val.amount = val.recAmount
                            total += val.amount;
                            val.accBalance = total;
                            if (val.amount < 0) {
                                val.amountNegetive = Math.abs(val.amount);
                                val.amount = 0;
                            } else {
                                val.amountNegetive = 0;
                            }
                        })
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            goEditPerson(item) {

                this.$router.push({path: '/dashboard/users/edit-user/' + item.userId});

            },
            goToDocuments(item) {
window.open('/dashboard/documents/show/' + item.masterId)
                // this.$router.push({path: '/dashboard/documents/show/' + item.masterId});

            },

            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form = item.id;

            }, delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeletePerson";


                formData.append('id', this.status_form);

                axios.post(url, formData, {}).then((res) => {
                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists();

                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
        }
    }

</script>
